import '@/assets/styles/_main.scss'
import 'gitart-vue-dialog/dist/style.css'
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from '@/App.vue'
import router from '@/router'
import { useAuthStore } from '@/stores'
import { GDialog } from 'gitart-vue-dialog'
import Toaster from '@meforma/vue-toaster'

startApp()

async function startApp() {
    const app = createApp(App)

    app.use(createPinia())
    app.use(Toaster, {
        position: 'top'
    })
    app.component('GDialog', GDialog)

    const authStore = useAuthStore()

    // Пробуємо зробити refresh, але не блокуємо старт додатка при помилці
    try {
        await authStore.refreshToken()
    } catch (error) {
        // Ігноруємо помилки - користувач або залогінений, або побачить login screen
        console.log('Initial token refresh failed, user will need to login')
    }

    app.use(router)

    app.mount('#app')
}
